const actionTypes = {
  INITIALISE_SELECTED_CHILD: "seneca/parentUi/INITIALISE_SELECTED_CHILD",
  SET_CHILD_USER_ID: "seneca/parentUi/SET_CHILD_USER_ID",
  SET_START_TIME: "seneca/parentUi/SET_START_TIME",
  SET_END_TIME: "seneca/parentUi/SET_END_TIME",
  SET_TIME_PERIOD: "seneca/parentUi/SET_TIME_PERIOD"
};

export default actionTypes;
